import { Modal, ModalProps } from 'components'
import { Dispatch, SetStateAction } from 'react'

export type SapModalTypes = 'sendModal' | 'returnModal' | 'salesAreaModal' | 'sendModalND'

const sapModalPropsByType: Record<
  SapModalTypes,
  Pick<ModalProps, 'title' | 'description' | 'buttonText' | 'buttonIcon' | 'showReturn'>
> = {
  sendModal: {
    title: 'Enviar ao SAP',
    description:
      'A fábrica dará continuidade à sua Ordem de Venda e os materiais só poderão ser editados novamente caso solicite o seu retorno.',
    buttonText: 'ENVIAR',
    showReturn: true
  },
  sendModalND: {
    title: 'Enviar para análise',
    description:
      'A sua OV concedeu um desconto, condição de pagamento e/ou prazo adicional maior do que o permitido para este cliente, por isso ela se tornou uma ND. Ela passará por uma análise e, caso seja aprovada, irá automaticamente ao SAP. Se for reprovada, ela voltará para o status 00 e você deverá atualizar os seus materiais ou justificativa para tentar novamente.',
    buttonText: 'ENVIAR',
    showReturn: true
  },
  returnModal: {
    title: 'Retornar',
    description: (
      <>
        <p>A sua OV poderá retornar da análise do Portal ou do SAP.</p>
        <p>
          Ao retornar, ela será transferida para o status 00, tornando-se pendente. No
          entanto, caso a OV já possua um número SAP, sua gestão será limitada.
        </p>
        <p>
          O retorno da OV pode não ser imediato, o que pode tornar o processo demorado.
        </p>
      </>
    ),
    showReturn: true,
    buttonText: 'RETORNAR'
  },
  salesAreaModal: {
    title: 'Devolver OV',
    description: 'Ao continuar, sua OV será devolvida para a área de vendas.',
    showReturn: false,
    buttonText: 'CONTINUAR'
  }
}
type SapModalProps = {
  handleButtonAction: () => void
  sapModal: SapModalTypes | undefined
  setSapModal: Dispatch<SetStateAction<SapModalTypes | undefined>>
}

const SapModal = ({ handleButtonAction, sapModal, setSapModal }: SapModalProps) => {
  const modalProps = sapModal
    ? sapModalPropsByType[sapModal]
    : sapModalPropsByType['sendModal']
  return (
    <Modal
      open={sapModal !== undefined}
      setOpen={() => {
        return
      }}
      buttonAction={() => {
        handleButtonAction()
        setSapModal(undefined)
      }}
      returnAction={() => setSapModal(undefined)}
      closeAction={() => setSapModal(undefined)}
      {...modalProps}
    />
  )
}

export default SapModal
